export default __webpack_public_path__ + "f905efcd6731867ecbfa49edb6045b37.png";